export default __webpack_public_path__ + "static/media/pieczatka12.8ad4bfd9.gif";